<template>
    <div class="w-full">
        <div class="button flex w-full justify-center" :class="{ 'hidden' : calculatedOffset >= numberOfItems}">
            <a v-on:click.stop.prevent="loadItems()" class="inline-block cursor-pointer">
                <div @mouseover="hover = true"
                     @mouseleave="hover = false"
                     class="post-item rounded-full flex flex-inline text-primarycolor tracking-widest leading-normal normal-case font-normal text-base px-4 py-1 pb-2">
                    {{ buttonText }}
                </div>
            </a>
        </div>
    </div>
</template>

<script>

    import axios from 'axios';
    import card from 'components/cards/card.vue'

    export default {
        components: {
            card
        },
        props: {
            numberOfItems: {
                type: Number
            },
            offset: {
                type: Number
            },
            url: {
                type: String
            },
            buttonText: {
                type: String
            },
        },
        data() {
            return {
                calculatedOffset: this.offset
            }
        },
        created() {
        },
        methods: {
            loadItems(){
                axios.post(this.url,
                        'offset=' + this.calculatedOffset, // the data to post
                ).then(response => {
                    if (response.data.length > 0) {
                        $(this.$el).before(response.data); //appends the items before the load more button
                        //offset * 2 to get the next amount of items (limit is applied via get-parameter in typo3 list view template)
                        this.calculatedOffset = this.calculatedOffset + this.offset
                    }

                }).catch(e => {
                    console.log(e)
                })
            },


        }
    };
</script>

<style rel="stylesheet/scss" lang="scss" type="text/css" scoped>
    .button {
        & .post-item {
            transition: all 0.1s ease-in-out;
            box-shadow: inset 0 0 0pt 1px theme('colors.primarycolor');

        }
        & .post-item:hover {
            box-shadow: inset 0 0 0pt 3px theme('colors.primarycolor');
            transition: all 0.1s ease-in-out;
        }
        .arrow-down {
            margin-left: 10px;
            margin-top: 5px;
        }
    }

    //if a button is followed by another button, we decrease margin-top
    .button {
        + .button {
            @apply mt-6;
        }
    }

</style>
